import React, { FC, HTMLAttributes } from 'react'
import { Box } from '@chakra-ui/core'
import { Hook } from '@engyalo/storefront-types'
import { IProduct } from '@engyalo/storefront-types/lib/plugins/model'
import { ProductItem } from '../ProductItem'
import { usePlugin } from '../../Plugin'

export enum ProductListFrom {
  COLLECTIONS = 'collections',
  SEARCH = 'search',
}

interface ICustomProduct extends IProduct {
  enabledPrice?: boolean
}

interface IProps extends HTMLAttributes<HTMLDivElement> {
  products: ICustomProduct[]
  from: ProductListFrom
  isLoading?: boolean
  showPrice?: boolean
}

const HOOK_FROM_LOCATION: { [key in ProductListFrom]: Hook } = {
  [ProductListFrom.COLLECTIONS]: Hook.CATALOGUE,
  [ProductListFrom.SEARCH]: Hook.SEARCH_CATALOGUE,
}

export const ProductList: FC<IProps> = ({ products, from, isLoading = false, showPrice = false }: IProps) => {
  const plugin = usePlugin(HOOK_FROM_LOCATION[from])
  const CustomContainer = plugin?.container ?? Box
  const pluginProps = plugin?.props ?? {}

  return (
    <CustomContainer
      display="grid"
      gridTemplateColumns="47% 47%"
      gridGap="8px 8px"
      justifyContent="center"
      {...pluginProps}
    >
      {products.map((product, index) => (
        <ProductItem
          key={product.name ?? `product-${index}`}
          product={product}
          isLoading={isLoading}
          showPrice={product?.enabledPrice || showPrice}
        />
      ))}
    </CustomContainer>
  )
}
